/**
 * ImageCompare
 * @description Web component used to compare images
 */

(async () => {
  if (!customElements.get('image-compare')) {

    class ImageCompare extends HTMLElement {
      constructor() {
        super();

        this.slider = this.querySelector('[data-image-comparison-slider]');
        this.sliderRange = this.querySelector('[data-image-comparison-range]');
        this.thumb = document.querySelector('[data-image-comparison-thumb]');

        if ('ontouchstart' in window === false) {
          this.sliderRange.addEventListener('mouseup', e => this.setSliderstate(e));
          this.sliderRange.addEventListener('mousedown', e => this.moveSliderThumb(e));
        }

        this.sliderRange.addEventListener('input', e => this.moveSliderRange(e));
        this.sliderRange.addEventListener('change', e => this.moveSliderRange(e));
      }

      resetSlider() {
        this.findWrapperElements();
        this.sliderRange.value = 50;
        this.slider.style.left = '50%';
        this.thumb.style.top = 'calc(50% - 16px)';
        this.imageWrapperOverlayBefore.style.width = '50%';
        this.imageWrapperOverlayAfter.style.width = '50%';
      }

      findWrapperElements() {
        this.imageWrapperOverlayBefore = this.imageWrapperOverlayBefore || this.querySelector('[data-image-comparison-overlay="before"]');
        this.imageWrapperOverlayAfter = this.imageWrapperOverlayAfter || this.querySelector('[data-image-comparison-overlay="after"]');
      }

      setSliderstate(e) {
        if (e.type === 'input') {
          this.sliderRange.classList.add('image-comparison__range--active');
          return;
        }

        this.sliderRange.classList.remove('image-comparison__range--active');
        this.removeEventListener('mousemove', this.moveSliderThumb(e));
      }

      moveSliderThumb(e) {
        let position = e.layerY - 20;

        if (e.layerY <= this.sliderRange.offsetTop) {
          position = -20;
        }

        if (e.layerY >= this.sliderRange.offsetHeight) {
          position = this.sliderRange.offsetHeight - 20;
        }

        this.thumb.style.top = `${position}px`;
      }

      moveSliderRange(e) {
        const value = e.target.value;
        this.findWrapperElements();

        this.slider.style.left = `${value}%`;
        this.imageWrapperOverlayBefore.style.width = `${value}%`;
        this.imageWrapperOverlayAfter.style.width = `${100 - value}%`;

        this.addEventListener('mousemove', this.moveSliderThumb(e));
        this.setSliderstate(e);
      }
    }

    window.ImageCompare = ImageCompare;

    customElements.define('image-compare', ImageCompare);
  }
})();
